import {createReducer} from "./index";
import * as R from 'ramda';
import {ADD_BID_CONTACTS, DELETE_BID_CONTACT} from "../actions/bidcontacts";

/*
Structure of bidcontacts model

{
  data: {
    [bidid]: {
      [contactuserid]: {
        bidid: string // uuid
        contactuserid: string // uuid
        active: bool
        wasautoarchived: bool
        archived: bool
        status: string // code-driven code_bidinvitestatus
        role: string // code-driven code_bidrole
        datecreated: datetime
      }
    }
  }
  indexes: {}
}
 */

const initial = {
  data: {},
  indexes: {}
};

export const bidContactsReducer = createReducer(initial,
  {
    [ADD_BID_CONTACTS]: (state, action) => {
      let newState = state;
      action.payload.forEach(contact => {
        newState = R.over(R.lensPath(['data', contact.bidid, contact.contactuserid]), () => contact)(newState);
      });
      return newState;
    },
    [DELETE_BID_CONTACT]: (state, action) => {
      const { bidId, userId } = action.payload;
      return R.dissocPath(['data', bidId, userId], state);
    }
    // 'ACTION_NAME': function (state, action) -> new_state
  });



// WEBPACK FOOTER //
// ./src/reducers/bidcontacts.js